import { https, httpsMultipart } from 'shared/utils/https';
import type {
  IGetUploadByFileTypeDTO,
  IGetUploadFileParamsDTO,
  IUploadListItemDTO,
  IUploadListResponse,
} from './uploads.dto';

const uploadsApiVersion = 'v1';

export const uploadsData = {
  getUploadList: async (): Promise<Array<IUploadListItemDTO>> => {
    const url = `${uploadsApiVersion}/import-files`;

    const { data } = await https.get<IUploadListResponse>(url);

    return data.importFilesToUpload;
  },
  getUploadByFileType: async (params: IGetUploadFileParamsDTO) => {
    const { channel, fileType } = params;

    const url = `${uploadsApiVersion}/channels/${channel}/customers/attributes/imports/latest`;

    const { data } = await https.get<IGetUploadByFileTypeDTO>(url, {
      params: { fileType },
    });

    return data;
  },
  uploadFile: async (params: IGetUploadFileParamsDTO, formData: FormData) => {
    const { channel } = params;

    const url = `${uploadsApiVersion}/channels/${channel}/customers/attributes/imports`;

    const { data } = await httpsMultipart.post<unknown>(url, formData);

    return data;
  },
};
